import { Component, Prop, Vue, Watch } from "vue-property-decorator";


@Component({
  name: 'AIMessageInput'
})
export default class AIMessageInput extends Vue {
  @Prop({ default: '' }) msg;
  @Prop({ default: false }) disabled;
  message = "";
  maxHeight = 150;
  minHeight = 60;
  height = 60;
  overflowY = "auto";
  heightAuto = false;

  @Watch("msg", {immediate: true}) onMessageChange(to, from) {
    this.message = to;
    // console.log({ 'ai-message-input.js:23 onMessageChange': to });
    this.$nextTick(() => {
      this.syncHeight();
    });
  }




  onInput(event) {
    // console.log({ 'ai-message-input.js:23 onInput': event.target.value });
    this.message = event.target.value;
    this.$emit('input', this.message);
    // this.syncHeight();
    // this.heightAuto = true;
    this.$nextTick(() => {
      this.syncHeight();
      // this.heightAuto = false;
    });
    // const textarea = event.target;
    // // textarea.style.height = "auto";
    // const scrollHeight = textarea.scrollHeight;
    // console.log({'ai-message-input.js:17 textarea.scrollHeight' : textarea.scrollHeight});
    // if (scrollHeight > textarea.offsetHeight && textarea.offsetHeight < 300) {
    //   this.height = scrollHeight;
    // } else  if (textarea.offsetHeight > 300) {
    //   this.height = 300;
    //   this.overflowY = "scroll";
    // }
  }

  syncHeight() {
    // const height = this.$refs?.["textarea"]?.scrollHeight;
    // this.height =
    //   height > this.maxHeight
    //     ? this.maxHeight
    //     : height < this.minHeight
    //       ? this.minHeight
    //       : height + 2; // Coming From DboxTextArea -> Added a Offset of 2 because a Mac Device from Simo was showing Scrollbars for 4th and 5th Row

    const textSizer = this.$refs?.["textsizer"];

    // Set height to the height of the textSizer
    this.height = textSizer.offsetHeight;
  }

  render() {
    return (
      <div class="ai-message-input-container">
        <div class="text-sizer" ref={"textsizer"}>
          {this.message}
        </div>
        <textarea
          class="ai-message-input"
          placeholder="Type your message here..."
          value={this.message}
          onInput={this.onInput}
          ref={"textarea"}
          autoFocus={true}
          onKeyup={(event) => {
            if (event.key === "Enter") {
              this.$emit("enter");
            }
          }}
          disabled={this.disabled}
          style={{
            height: `${this.height}px`,
            overflow: this.message && this.message.length > 0 ? 'auto' : 'hidden',
            maxHeight: `150px`,
            minHeight: `60px`,
            opacity: this.disabled ? '0.5' : '1',
            
          }}
        ></textarea>
      </div>
    );
  }
}